export const MenuData = [
{
    'id' : 1,
    'price' : 150,
    'title' : 'Chicken Burger',
    'desc' : 'Ipsum ipsum clita erat amet dolor justo diam',
    'img' : require('./../../assests/img/menu-1.jpg')
},
{
    'id' : 2,
    'price' : 150,
    'title' : 'Chicken Burger',
    'desc' : 'Ipsum ipsum clita erat amet dolor justo diam',
    'img' : require('./../../assests/img/menu-2.jpg')
},
{
    'id' : 3,
    'price' : 150,
    'title' : 'Chicken Burger',
    'desc' : 'Ipsum ipsum clita erat amet dolor justo diam',
    'img' : require('./../../assests/img/menu-3.jpg')
},
{
    'id' : 4,
    'price' : 150,
    'title' : 'Chicken Burger',
    'desc' : 'Ipsum ipsum clita erat amet dolor justo diam',
    'img' : require('./../../assests/img/menu-4.jpg')
},
{
    'id' : 5,
    'price' : 150,
    'title' : 'Chicken Burger',
    'desc' : 'Ipsum ipsum clita erat amet dolor justo diam',
    'img' : require('./../../assests/img/menu-5.jpg')
},
{
    'id' : 6,
    'price' : 150,
    'title' : 'Chicken Burger',
    'desc' : 'Ipsum ipsum clita erat amet dolor justo diam',
    'img' : require('./../../assests/img/menu-6.jpg')
},
{
    'id' : 7,
    'price' : 150,
    'title' : 'Chicken Burger',
    'desc' : 'Ipsum ipsum clita erat amet dolor justo diam',
    'img' : require('./../../assests/img/menu-7.jpg')
},
{
    'id' : 8,
    'price' : 150,
    'title' : 'Chicken Burger',
    'desc' : 'Ipsum ipsum clita erat amet dolor justo diam',
    'img' : require('./../../assests/img/menu-8.jpg')
},
]
